import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';

export const approvalApi = createApi({
  reducerPath: 'approvalApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['PendingApprovals'],
  endpoints: (builder) => ({
    createApproval: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/Approval/create`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['PendingApprovals'],
    }),
    initiateApproval: builder.query<any, string>({
      query: (scheduleId) => ({
        url: `api/v1/Approval/transaction/confirm/${scheduleId}`,
        method: 'GET',
      }),
    }),
    confirmTransaction: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/Approval/transaction/confirm`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['PendingApprovals'],
    }),
    getPendingApprovals: builder.query<any, void>({
      query: () => ({
        url: `api/v1/Approval/transactions`,
        method: 'GET',
      }),
      providesTags: ['PendingApprovals'],
    }),
  }),
});

export const {
  useCreateApprovalMutation,
  useInitiateApprovalQuery,
  useConfirmTransactionMutation,
  useGetPendingApprovalsQuery,
} = approvalApi;
